"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCKEditorText = exports.getCKEditorData = void 0;
function getCKEditorData(CKEditorId) {
    return window.CKEDITOR.instances[CKEditorId].getData();
}
exports.getCKEditorData = getCKEditorData;
function getCKEditorText(CKEditorId) {
    return window.CKEDITOR.instances[CKEditorId].document.getBody().getText();
}
exports.getCKEditorText = getCKEditorText;
//# sourceMappingURL=CKEditorUtils.js.map